import { FC } from "react";
import { Image } from "@mantine/core";
import { useTeam } from "../hooks/useTeam.ts";

interface TeamLogoProps {
  teamId?: string;
  height?: number;
}

export const TeamLogo: FC<TeamLogoProps> = (props) => {
  const { teamId, height } = props;

  const teamData = useTeam(teamId);

  return (
    <Image
      src={teamData.data?.logoFilePath}
      fallbackSrc={`https://placehold.co/500x500?text=${teamData.data?.shortName ?? "Logo"}`}
      height={height}
      fit="contain"
      alt={`Logo ${teamData.data?.shortName ?? "Platzhalter"}`}
      title={teamData.data?.name}
    />
  );
};
